var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "networong-page", attrs: { id: "page_Container" } },
      [
        _c("div", { staticClass: "page" }, [
          _c(
            "div",
            {
              staticClass: "page-style main-container",
              attrs: { id: "main-container" }
            },
            [
              _c("div", { staticClass: "tips" }, [
                _vm._v("加载异常，请关闭页面重新进入～")
              ])
            ]
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }